import React from "react";
import { Inner } from "./styles";
import DistributorsSelectorSellers from "../../../../../../../common/distributor-selector-sellers/DistributorsSelectorSellers";

export default function DistributorModal({
	setDistributors,
	distributors,
	isSeller,
	isOneMarket,
	blockedValues,
}) {
	return (
		<Inner>
			<DistributorsSelectorSellers
				onChange={setDistributors}
				initialValues={distributors}
				noBuyer={isSeller || isOneMarket ? true : false}
				blockedValues={blockedValues}
			/>
		</Inner>
	);
}
